import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Globe, Phone } from "lucide-react";
import RestrictionBadge from "./RestrictionBadge";
import { fileUrl } from "../lib/api";

export default function PlaceCard({ place }) {
  const img = place.photo_path ? fileUrl(place.photo_path) : null;
  return (
    <Link
      to={`/lugar/${place.place_id}`}
      data-testid={`place-card-${place.place_id}`}
      className="group bg-white rounded-3xl border border-brand-border shadow-[0_2px_8px_rgba(42,92,67,0.06)] hover:shadow-[0_12px_32px_rgba(42,92,67,0.12)] hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
    >
      <div className="relative aspect-[4/3] bg-brand-bg overflow-hidden">
        {img ? (
          <img src={img} alt={place.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-brand-bg to-[#E5E0D8] text-brand-textMuted text-sm font-bold">
            Sem foto
          </div>
        )}
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {(place.restrictions || []).map((r) => <RestrictionBadge key={r} type={r} />)}
        </div>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <h3 className="font-heading font-bold text-xl text-brand-text leading-tight">{place.name}</h3>
        <div className="flex items-center gap-1.5 text-sm text-brand-textMuted">
          <MapPin className="w-4 h-4 shrink-0" />
          <span className="truncate">{place.city} · {place.state}</span>
        </div>
        <p className="text-sm text-brand-textMuted line-clamp-2">{place.description}</p>
        <div className="flex items-center gap-3 pt-1 text-xs text-brand-textMuted">
          {place.website && <span className="inline-flex items-center gap-1"><Globe className="w-3 h-3" /> site</span>}
          {place.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" /> {place.phone}</span>}
        </div>
      </div>
    </Link>
  );
}
